import Command from '../../actions/command';
import {call, fork, put, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import {SetCompanyTesterPayload} from '../../actions/companyCommand';
import Event from '../../actions/event';
import Api from '../../../api';
import {User} from '../../types/User';

const onSetCompanyTester = function*(data: SetCompanyTesterPayload) {
    let userId: string;

    try {
        const user: User = yield call(Api.Query.userByEmail, data.email);
        userId = user.id;
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Es konnte kein Nutzer mit dieser E-Mail Adresse gefunden werden.',
        }));
        return;
    }

    try {
        yield call(Api.Command.setCompanyTester, {
            companyId: data.companyId,
            userId: userId,
        });

        yield put(Event.Company.companyTesterSet({
            companyId: data.companyId,
            userId: userId,
        }));

        yield put(Command.Notification.enqueueNotification({
            severity: 'success',
            message: 'Der Tester wurde zugewiesen.',
        }));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Der Tester konnte nicht zugewiesen werden.',
        }));
    }
};

export function* setCompanyTesterFlow() {
    while (true) {
        const action: Action<SetCompanyTesterPayload> = yield take(
            Command.Company.setCompanyTester.toString(),
        );

        yield fork(onSetCompanyTester, action.payload);
    }
}
